import { useMutation, useQueryClient } from "@tanstack/react-query"

import { updateQuestionnaire } from "../../services/questionnaires";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useUpdateQuestionnaire = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateQuestionnaire,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (statusCode) => {
            if (statusCode === 200) {
                queryClient.invalidateQueries({ queryKey: ["questionnaires"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Questionnaire updated successfully");
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    })
}

export default useUpdateQuestionnaire;